import React, { useEffect, useState } from "react";
import {
    MenuItem, Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, TextField, TablePagination, Dialog, DialogTitle, DialogContent, DialogActions, Button
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Money";
import ReceiptLongIcon from "@mui/icons-material/EditDocument";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { db } from "../../firebase";
import {
    collection, onSnapshot, deleteDoc, doc, updateDoc, query, orderBy, where, Timestamp
} from "firebase/firestore";

function Viewtrips() {
    const navigate = useNavigate();
    const [trips, setTrips] = useState([]);
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(200);
    const [editOpen, setEditOpen] = useState(false);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [editData, setEditData] = useState({});
    const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
    const [selectedPaymentTrip, setSelectedPaymentTrip] = useState(null);
    const [imageOpen, setImageOpen] = useState(false);
    const [selectedImages, setSelectedImages] = useState({ tarePhotos: [], grossPhotos: [] });
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
    const [throughDetails, setThroughDetails] = useState([]);

    const handleViewImages = (trip) => {
        setSelectedImages({ tarePhotos: trip.tarePhotos || [], grossPhotos: trip.grossPhotos || [] });
        setImageOpen(true);
    };

    useEffect(() => {

        const unsub = onSnapshot(
            collection(db, "throughdetails"),
            (snapshot) => {
                setThroughDetails(
                    snapshot.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }))
                );

            }
        );

        return () => unsub();

    }, []);

    useEffect(() => {
        const start = new Date(selectedDate);
        start.setHours(0, 0, 0, 0);

        const end = new Date(selectedDate);
        end.setHours(23, 59, 59, 999);
        const q = query(collection(db, "trips"), where("status", "==", "Completed"), where("grossDate", ">=", start), where("grossDate", "<=", end), orderBy("grossDate", "desc")
        );

        const unsub = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs
                .map(doc => ({ id: doc.id, ...doc.data() }))
                .sort((a, b) => {
                    const challanA = Number(a.challan || 0);
                    const challanB = Number(b.challan || 0);
                    return challanA - challanB; // Ascending
                    // return challanB - challanA; // Descending
                });
            setTrips(data);
        });
        return () => unsub();
    }, [selectedDate]);
    // DELETE
    const handleDelete = async (id) => {

        Swal.fire({
            title: "Delete Trip?",
            text: "This record will be permanently deleted.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            confirmButtonText: "Yes Delete"
        }).then(async (result) => {

            if (result.isConfirmed) {
                await deleteDoc(doc(db, "trips", id));
                Swal.fire("Deleted!", "Trip removed successfully", "success");
            }
        });
    };

    const handleEdit = (trip) => {

        setSelectedTrip(trip.id);

        setEditData({
            ...trip,
            throughId: trip.throughId || "",
            throughName: trip.throughName || "",

            grossDate: trip.grossDate
                ? new Date(trip.grossDate.toDate())
                    .toISOString()
                    .slice(0, 16)
                : "",

            tareDate: trip.tareDate
                ? new Date(trip.tareDate.toDate())
                    .toISOString()
                    .slice(0, 16)
                : ""
        });

        setEditOpen(true);
    };


    const handleUpdate = async () => {
        try {
            await updateDoc(
                doc(db, "trips", selectedTrip),
                {
                    customerName: editData.customerName || "",
                    vehicleNo: editData.vehicleNo || "",
                    mobile: editData.mobile || "",
                    location: editData.location || "",

                    throughId: editData.throughId || "",
                    throughName: editData.throughName || "",

                    grossDate: editData.grossDate
                        ? Timestamp.fromDate(
                            new Date(editData.grossDate)
                        )
                        : null,

                    tareDate: editData.tareDate
                        ? Timestamp.fromDate(
                            new Date(editData.tareDate)
                        )
                        : null
                }
            );
            Swal.fire("Updated", "Trip updated successfully", "success");
            setEditOpen(false);

        } catch (err) {
            Swal.fire("Error", err.message, "error");
        }
    };

    const handlePaymentHistory = (trip) => {
        setSelectedPaymentTrip(trip);
        setPaymentDialogOpen(true);
    };

    const filteredTrips = trips.filter((trip) =>
        JSON.stringify(trip).toLowerCase().includes(search.toLowerCase())
    );

    const handleDeletePayment = async (tripId, paymentIndex) => {
        const payment =
            selectedPaymentTrip?.payments?.[paymentIndex];

        const result = await Swal.fire({
            title: "Delete Payment Entry?",
            html: `
            <div style="text-align:left">
                <p><b>Amount:</b> ₹${payment?.amount || 0}</p>
                <p><b>Mode:</b> ${payment?.mode || "-"}</p>
                <p><b>Note:</b> ${payment?.note || "-"}</p>
            </div>
        `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Delete Payment",
            cancelButtonText: "Cancel",
            reverseButtons: true
        });

        if (!result.isConfirmed) return;

        try {
            const tripRef = doc(db, "trips", tripId);

            const updatedPayments =
                selectedPaymentTrip.payments.filter(
                    (_, index) => index !== paymentIndex
                );

            const totalPaid = updatedPayments.reduce(
                (sum, p) => sum + Number(p.amount || 0),
                0
            );

            const remaining =
                Number(selectedPaymentTrip.totalAmount || 0) -
                totalPaid;

            await updateDoc(tripRef, {
                payments: updatedPayments,
                paidAmount: totalPaid,
                remainingAmount: remaining,
            });

            setSelectedPaymentTrip(prev => ({
                ...prev,
                payments: updatedPayments,
                paidAmount: totalPaid,
                remainingAmount: remaining,
            }));

            Swal.fire({
                icon: "success",
                title: "Deleted",
                text: "Payment entry removed successfully",
                timer: 1500,
                showConfirmButton: false
            });

        } catch (error) {
            Swal.fire(
                "Error",
                error.message,
                "error"
            );
        }
    };

    return (

        <Box sx={{
            bgcolor: '#f4f6f8', minHeight: '100vh', p: 1,
            "& .MuiInputBase-root": { fontSize: "14px" },
            "& .MuiTableCell-root": { fontSize: "13px", padding: "2px 2px" },
            "& .MuiButton-root": { fontSize: "11px", padding: "4px 8px" }
        }} >
            <Paper sx={{ p: 2 }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} >
                    <Typography variant="h6"> Trips List </Typography>
                    <TextField type="date" size="small" label="Filter Date" InputLabelProps={{ shrink: true }} value={selectedDate}
                        onChange={(e) => setSelectedDate(e.target.value)} />
                    <TextField size="small" label="Search" value={search} onChange={(e) => setSearch(e.target.value)} />
                </Box>

                <TableContainer >
                    <Table size="small">
                        <TableHead>
                            <TableRow sx={{ background: "#f5f5f5" }}>
                                <TableCell>SR</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Chalan No</TableCell> {/* ✅ NEW */}
                                <TableCell>Ticket</TableCell> {/* ✅ NEW */}
                                <TableCell>Party</TableCell>
                                <TableCell>Vehicle</TableCell>
                                <TableCell>Product</TableCell>
                                <TableCell align="center">Qty</TableCell>
                                <TableCell>Total</TableCell>
                                <TableCell>Paid</TableCell> {/* ✅ NEW */}
                                <TableCell>Remain</TableCell> {/* ✅ NEW */}
                                <TableCell>Pay Mode</TableCell> {/* ✅ NEW */}
                                <TableCell>Net Wt</TableCell>
                                <TableCell>Through</TableCell>
                                <TableCell align="center">Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {filteredTrips.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const totalSale = row.products?.reduce((sum, p) => sum + (Number(p.amount) || 0), 0) || 0;
                                    return (
                                        <TableRow key={row.id} hover>
                                            <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                            <TableCell>
                                                {row.grossDate ?
                                                    new Intl.DateTimeFormat('en-GB', {
                                                        day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit'
                                                    }).format(row.grossDate.toDate())
                                                    : ""
                                                }
                                            </TableCell>
                                            <TableCell>{row.challan}</TableCell>
                                            <TableCell>{row.ticketNo}</TableCell>
                                            <TableCell>{row.customerName}</TableCell>
                                            <TableCell>{row.vehicleNo}</TableCell>
                                            <TableCell>{row.products?.map((p, i) => (
                                                <Typography key={i} sx={{ fontSize: "0.8rem" }}>
                                                    {i + 1}) {p.productName}
                                                </Typography>
                                            ))}
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.products?.map((p, i) => (
                                                    <Typography key={i} sx={{ fontSize: "0.8rem" }}>
                                                        {p.qty}
                                                    </Typography>
                                                ))}
                                            </TableCell>
                                            <TableCell>
                                                <Typography fontWeight="bold">
                                                    ₹ {Math.round(row.totalAmount || totalSale).toLocaleString()}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography color="green" fontWeight="bold" sx={{
                                                    cursor: "pointer", textDecoration: "underline"
                                                }} onClick={() => handlePaymentHistory(row)} >
                                                    ₹ {Math.round(row.paidAmount || 0).toLocaleString()}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography
                                                    color={(row.remainingAmount || 0) > 0 ? "error" : "success"}
                                                    fontWeight="bold" >
                                                    ₹ {Math.round(row.remainingAmount || 0).toLocaleString()}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                {row.payments && row.payments.length > 0 ? (
                                                    row.payments.map((p, i) => (
                                                        <Typography key={i} sx={{ fontSize: "0.75rem" }}>
                                                            {p.mode} - ₹{p.amount}
                                                        </Typography>
                                                    ))
                                                ) : (
                                                    "-"
                                                )}
                                            </TableCell>

                                            <TableCell> {row.netWeight} </TableCell>
                                            <TableCell> {row.throughName || "-"}  </TableCell>

                                            <TableCell align="center">
                                                <IconButton color="secondary" onClick={() => handleEdit(row)} title="Quick Edit">
                                                    <ReceiptLongIcon />
                                                </IconButton>
                                                <IconButton color="primary" onClick={() => navigate(`/edit-trip/${row.id}`)} title="Full Edit" >
                                                    <EditIcon />
                                                </IconButton>
                                                <IconButton color="success" onClick={() => handlePaymentHistory(row)} title="Payment History" >
                                                    <VisibilityIcon />
                                                </IconButton>
                                                <IconButton color="error" onClick={() => handleDelete(row.id)} title="Delete Trip" >
                                                    <DeleteIcon />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>

                <Dialog open={paymentDialogOpen} onClose={() => setPaymentDialogOpen(false)} maxWidth="md" fullWidth >
                    <DialogTitle>Payment History</DialogTitle>
                    <DialogContent>
                        <Typography> Total Amount : ₹ {selectedPaymentTrip?.totalAmount || 0} </Typography>
                        <Typography color="green"> Paid : ₹ {selectedPaymentTrip?.paidAmount || 0} </Typography>
                        <Typography color="error"> Remaining : ₹ {selectedPaymentTrip?.remainingAmount || 0} </Typography>
                        <Table size="small" sx={{ mt: 2 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Mode</TableCell>
                                    <TableCell>Amount</TableCell>
                                    <TableCell>Note</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {selectedPaymentTrip?.payments?.map((p, index) => (
                                    <TableRow key={index}>
                                        <TableCell> {p.date?.seconds ? new Date(p.date.seconds * 1000).toLocaleString() : "-"} </TableCell>
                                        <TableCell> {p.mode} </TableCell>
                                        <TableCell> ₹ {p.amount} </TableCell>
                                        <TableCell> {p.note || "-"} </TableCell>
                                        <TableCell>
                                            <IconButton color="error" onClick={() => handleDeletePayment(selectedPaymentTrip.id, index)} >
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setPaymentDialogOpen(false)} > Close </Button>
                    </DialogActions>
                </Dialog>

                <TablePagination
                    component="div"
                    count={filteredTrips.length}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={(e, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(e) => {
                        setRowsPerPage(parseInt(e.target.value, 10));
                        setPage(0);
                    }}
                />
            </Paper>

            <Dialog open={editOpen} onClose={() => setEditOpen(false)} maxWidth="sm" fullWidth >

                <DialogTitle> Edit Trip </DialogTitle>
                <DialogContent>
                    <TextField label="Customer Name" fullWidth size="small" margin="dense" value={editData.customerName || ""}
                        onChange={(e) => setEditData({ ...editData, customerName: e.target.value })} />

                    <TextField label="Vehicle No" fullWidth size="small" margin="dense" value={editData.vehicleNo || ""}
                        onChange={(e) => setEditData({ ...editData, vehicleNo: e.target.value })} />

                    <TextField label="Mobile" fullWidth size="small" margin="dense" value={editData.mobile || ""}
                        onChange={(e) => setEditData({ ...editData, mobile: e.target.value })} />

                    <TextField label="Location" fullWidth size="small" margin="dense" value={editData.location || ""}
                        onChange={(e) => setEditData({ ...editData, location: e.target.value })} />

                    <TextField label="Tare Date & Time" type="datetime-local" fullWidth size="small" margin="dense"
                        InputLabelProps={{ shrink: true }} value={editData.tareDate || ""} onChange={(e) =>
                            setEditData({ ...editData, tareDate: e.target.value })} />

                    <TextField label="Gross Date & Time" type="datetime-local" fullWidth size="small" margin="dense"
                        InputLabelProps={{ shrink: true }} value={editData.grossDate || ""} onChange={(e) =>
                            setEditData({ ...editData, grossDate: e.target.value })} />

                    <TextField select label="Through Detail" fullWidth size="small" margin="dense" value={editData.throughId || ""}
                        onChange={(e) => {
                            const selected = throughDetails.find(t => t.id === e.target.value);
                            setEditData({ ...editData, throughId: selected?.id || "", throughName: selected?.name || "" });
                        }} >
                        <MenuItem value=""> Select Through </MenuItem>
                        {throughDetails.map((item) => (
                            <MenuItem key={item.id} value={item.id} > {item.name} </MenuItem>
                        ))}
                    </TextField>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEditOpen(false)}> Cancel </Button>
                    <Button variant="contained" onClick={() => handleUpdate()} > Update </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={imageOpen} onClose={() => setImageOpen(false)} maxWidth="md" fullWidth >
                <DialogTitle>Trip Photos</DialogTitle>
                <DialogContent>
                    <Typography fontWeight="bold" mt={1}>Tare Photos</Typography>
                    <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
                        {selectedImages.tarePhotos.length > 0 ? (
                            selectedImages.tarePhotos.map((url, i) => (
                                <img key={i} src={url} alt={`Tare ${i}`} style={{ width: 250, height: 150, objectFit: "cover", borderRadius: 4, border: "1px solid #ccc" }}
                                />
                            ))
                        ) : (
                            <Typography variant="body2">No Tare photos available</Typography>
                        )}
                    </Box>

                    <Typography fontWeight="bold" mt={1}>Gross Photos</Typography>
                    <Box display="flex" flexWrap="wrap" gap={1}>
                        {selectedImages.grossPhotos.length > 0 ? (
                            selectedImages.grossPhotos.map((url, i) => (
                                <img key={i} src={url} alt={`Gross ${i}`} style={{ width: 250, height: 150, objectFit: "cover", borderRadius: 4, border: "1px solid #ccc" }}
                                />
                            ))
                        ) : (
                            <Typography variant="body2">No Gross photos available</Typography>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setImageOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>

    );

}

export default Viewtrips;